<script setup lang="ts">
/**
 * /job-application-tracker — the page for the Applications board
 * (pages/applications.vue), written for what people search: "job application
 * tracker", "track job applications", "job search tracker".
 */
const { t } = useI18n()
const { faqPageNode } = useJsonLd()

definePageMeta({
  layout: false,
  auth: false,
})

// Its URL in Czech, German and Polish (constants/localizedRoutes.ts).
false && /*#__PURE__*/ defineI18nRoute({ paths: { cs: '/prehled-pracovnich-prihlasek', de: '/bewerbungstracker', pl: '/organizer-aplikacji-o-prace' } })

/** Answered in prose on the page, and mirrored into FAQPage structured data. */
const FAQ_IDS = ['what', 'why', 'followUp', 'versions', 'private', 'free'] as const

const faqItems = computed(() =>
  FAQ_IDS.map(id => ({
    id,
    question: t(`trackerPage.faq.${id}.q`),
    answer: t(`trackerPage.faq.${id}.a`),
  })),
)

const extraNodes = computed(() => [faqPageNode('/job-application-tracker', faqItems.value)])
</script>

<template>
  <MarketingFeaturePage
    seo-key="jobTracker"
    path="/job-application-tracker"
    :breadcrumb-title="t('trackerPage.heading')"
    :extra-nodes="extraNodes"
  >
    <MarketingTrackerGuide />

    <!-- The pack's link for one company: when the company opened the CV -->
    <MarketingLinkTrackingShowcase />

    <MarketingFaqSection
      :title="t('trackerPage.faq.title')"
      :items="faqItems"
      name="tracker-faq"
    />
  </MarketingFeaturePage>
</template>
